module.exports = "//public.zight.com/packs/media/images/icons-bug-41f3c1969a4dcb709730ad9238571f0c.svg";